import { render, staticRenderFns } from "./StepsOptionsHair.vue?vue&type=template&id=05a52107"
import script from "./StepsOptionsHair.vue?vue&type=script&lang=js"
export * from "./StepsOptionsHair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports